module.exports = __webpack_public_path__ + "assets/img/xixun.04216abb.jpg";